import React from 'react';
import PropTypes from 'prop-types';

import { CustomSelect } from './styles';

function Select({ id, children, onChange, margin, right }) {
  return (
    <CustomSelect
      id={id}
      name={id}
      onChange={onChange}
      margin={margin}
      right={right}
    >
      {children}
    </CustomSelect>
  );
}

Select.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
  margin: PropTypes.bool,
  right: PropTypes.bool,
};

Select.defaultProps = {
  margin: false,
  right: false,
};

export default Select;
